import React, { Component } from 'react';
import queryString from 'query-string';
import { Table, Input } from 'antd';
import { backendErrorTip } from '../../../utils';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import columns from './columns';
import xfetch from '../../../xfetch';
import s from './style.css';

const { Search } = Input;

@withStyles(s)
export default class HistoryAnswer extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
    };
    this.baseApi = `${window.G.backendApi}/history/answer/`;
  }
  state = {
    data: {},
    loading: true,
    selectedRowKeys: [],
  };
  componentDidMount() {
    this.query();
  }
  onTableChange = pagination => {
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  onSelectChange = selectedRowKeys => this.setState({ selectedRowKeys });
  query = () => {
    const api = `${this.baseApi}?${queryString.stringify(this.q)}`;
    xfetch(api).then(({ error, result }) => {
      this.setState({
        loading: false,
      });
      if (error) {
        backendErrorTip(error);
        return;
      }
      this.setState({
        data: result,
      });
    });
  };
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      selectedRowKeys,
    } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };
    return (
      <div className={s.wrap}>
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <Search
              placeholder="输入答案内容搜索"
              onSearch={this.handleSearch}
              style={{ width: 260 }}
              enterButton="搜索"
            />
          </div>
        </div>
        <div className={s.table}>
          <Table
            loading={loading}
            dataSource={results}
            columns={columns(this, s)}
            rowSelection={rowSelection}
            pagination={pagination}
            onChange={this.onTableChange}
          />
        </div>
      </div>
    );
  }
}
